import {
  SampleGroup,
  sampleGroupZod,
} from 'packages/lib/api/annotations/contract/sample-group';
import { apiGet } from 'packages/lib/api/annotations/rest';
import useSWR, { SWRResponse } from 'swr';
import { dispatchErrorToast } from 'packages/lib/common-ui/toast/api-toast';

const REFRESH_RATE_MS = 0; // disabled

export const useSampleGroupsForInstruction = (
  instructionToken: string | null | undefined
): SWRResponse<SampleGroup[]> =>
  useSWR<SampleGroup[]>(
    instructionToken
      ? `/sample-groups?instructionToken=${instructionToken}`
      : undefined,
    (url) =>
      apiGet<SampleGroup[]>(url, sampleGroupZod.array().parse).catch((err) => {
        dispatchErrorToast(
          `Failed to fetch sample groups for this annotation instruction. Please report this error and include browser console outputs.`
        );
        console.log(
          `Failed to fetch SampleGroups for instruction token: ${url}`
        );
        throw err;
      }),
    {
      refreshInterval: REFRESH_RATE_MS,
      revalidateIfStale: false,
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
    }
  );
